import React, {Component, ReactElement, ReactNode} from 'react'
import {
    ADMINISTORATOR_MODE,
    EVENT_CATEGORY,
    EVENT_ITEM_CLEANING,
    EVENT_ITEM_GARBAGE_DAY,
    EVENT_ITEM_MAINTENANCE,
    EVENT_ITEM_OTHER,
    EVENT_ITEM_OTHER_EVENTS,
    MESSAGE_TYPE,
    PREFECTURES_MASTER,
    VALID_OR_NOT_CHECK,
    YES_OR_NOT,
} from '../../../CodeMaster'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Messages} from '../../../Messages'
import {Nullable} from '../../../app/TypeHelpers'
import {
    InnerMiniTable,
    InnerMiniTableBody,
    InnerMiniTableCell,
    StyledTableCaption,
    TableRowName,
} from '../../../styledComponents/adminPage/Table'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, DeleteLink} from '../../../styledComponents/adminPage/Links'
import {formatDateZeroPadding} from '../../../formatters/formatDate'
import {Box, Link, Table, TableBody, TableCell, TableRow} from '@mui/material'
import NatScheduleRepo from './repository/NatScheduleRepo'
import {NatGetSchedule, ScheduleNotDeliveryCondominiumList} from './repository/NatGetSchedule'
import SortableTableHeader, {
    SortableTableHeaderCell,
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader'
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable'
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody'
import {SortOrder} from '../../../components/shared/SortOrder'
import NatEventRepo from '../event/repository/NatEventRepo'
import {
    EventInfo,
    NatGetEventList,
    SearchCondition,
    SearchConditionPageInfo,
    SearchResult,
} from '../event/repository/NatGetEventList'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {NatDeleteSchedule} from './repository/NatDeleteSchedule'
import {getScheduleSettingInfo} from '../../common/util/Natutil'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import styled from 'styled-components'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {
    BillingStatus,
    CondominiumInfo,
    NatGetCondominiumList,
    SearchCondition as SearchConditionList,
    SearchConditionPageInfo as CondominiumSearchConditionPageInfo,
} from '../condominium/repository/NatGetCondominiumList'
import {Location} from 'react-router-dom'
import ReactDOM from 'react-dom'

const SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'
const KEY_SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'

interface Props {
    scheduleId: string
    scheduleRepo: NatScheduleRepo
    eventRepo: NatEventRepo
    eventEmitter: EventEmitterExAdmin
    condominiumRepo: NatCondominiumRepo
    location: Location
}

interface States {
    eventList: EventInfo[]
    eventSearchResult: SearchResult
    schedule: NatGetSchedule
    scheduleTitle: string
    eventCategory: string
    eventItem: string
    scheduleTermDate: string
    description: string
    scheduleSetting: string
    condominiumName: string,
    condominiumGroupName: string,
    deliveryTargetPrefectureCd: string,
    deliveryTargetAddress2: string,
    scheduleDeliveryTargetCondominiumList: CondominiumInfo[],
    scheduleNotDeliveryCondominium: ScheduleNotDeliveryCondominiumList[],
    searchConditionSortInfo: SortOrder[]
    searchCondition: SearchCondition
    searchConditionPageInfo: SearchConditionPageInfo
    isLoadCompleted: boolean
    deleteImpossibleFlg: boolean
}


class NatAdminScheduleDetailsPage extends Component<Props & AdminPagePropsSet, States> {
    mode: Nullable<string>
    condominiumCd: Nullable<string>
    subSortKey: SortOrder[] = [
        new SortOrder('scheduleId', 'asc'),
        new SortOrder('seq', 'asc'),
    ]

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.mode = SessionStorageHelper.getStringItemOrNull(SELECTED_ADMINISTORATOR_MODE)
        this.condominiumCd = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_CD)

        this.state = {
            eventList: [],
            eventSearchResult: {},
            schedule: {
                details: null,
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            scheduleTitle: '',
            eventCategory: '',
            eventItem: '',
            scheduleTermDate: '',
            description: '',
            scheduleSetting: '',
            deliveryTargetPrefectureCd: '',
            deliveryTargetAddress2: '',
            scheduleDeliveryTargetCondominiumList: [],
            scheduleNotDeliveryCondominium: [],
            condominiumName: '',
            condominiumGroupName: '',
            searchCondition: {
                scheduleId: this.props.scheduleId,
            },
            searchConditionPageInfo: {
                pageNum: COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0],
                page: COMMON_CONSTANTS.FIRST_PAGE,
            },
            searchConditionSortInfo: [
                new SortOrder('operationDate', 'asc'),
            ],
            isLoadCompleted: false,
            deleteImpossibleFlg: false,
        }
        this.backScheduleListLinkClick = this.backScheduleListLinkClick.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.editScheduleLinkClick = this.editScheduleLinkClick.bind(this)
        this.deleteSchedule = this.deleteSchedule.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleDeleteOkClick = this.handleDeleteOkClick.bind(this)
        this.renderEventTable = this.renderEventTable.bind(this)
        this.renderEventRecord = this.renderEventRecord.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // スケジュール取得
            const schedule: Nullable<NatGetSchedule> = await this.props.asyncCallFunction(
                this.props.scheduleRepo.getSchedule.bind(this.props.scheduleRepo, this.props.scheduleId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (schedule && schedule.details) {
                // イベントカテゴリ
                const eventCategoryMaster = EVENT_CATEGORY.codeToEnumConstants(schedule.details.eventCategory)
                let eventCategory: string = ''
                if (eventCategoryMaster) {
                    eventCategory = eventCategoryMaster.label
                }
                // イベント項目
                let eventItem: string = ''
                switch (schedule.details.eventCategory) {
                    case EVENT_CATEGORY.TRASH_DAY.value:
                        const garbageMaster =
                            EVENT_ITEM_GARBAGE_DAY.codeToEnumConstants(schedule.details.eventItem)
                        if (garbageMaster) {
                            eventItem = garbageMaster.label
                        }
                        break
                    case EVENT_CATEGORY.MAINTENANCE.value:
                        const maintenanceMaster =
                            EVENT_ITEM_MAINTENANCE.codeToEnumConstants(schedule.details.eventItem)
                        if (maintenanceMaster) {
                            eventItem = maintenanceMaster.label
                        }
                        break
                    case EVENT_CATEGORY.CLEANING.value:
                        const cleaningMaster =
                            EVENT_ITEM_CLEANING.codeToEnumConstants(schedule.details.eventItem)
                        if (cleaningMaster) {
                            eventItem = cleaningMaster.label
                        }
                        break
                    case EVENT_CATEGORY.OTHER_EVENT.value:
                        const otherEventsMaster =
                            EVENT_ITEM_OTHER_EVENTS.codeToEnumConstants(schedule.details.eventItem)
                        if (otherEventsMaster) {
                            eventItem = otherEventsMaster.label
                        }
                        break
                    case EVENT_CATEGORY.OTHER.value:
                        const otherMaster =
                            EVENT_ITEM_OTHER.codeToEnumConstants(schedule.details.eventItem)
                        if (otherMaster) {
                            eventItem = otherMaster.label
                        }
                        break
                    default:
                        break
                }
                // 実施期間
                let scheduleTermDate: string = ''
                if (!schedule.details.scheduleEndDate) {
                    scheduleTermDate = formatDateZeroPadding(schedule.details.scheduleStartDate)
                } else {
                    scheduleTermDate = `${formatDateZeroPadding(schedule.details.scheduleStartDate)}から
                    ${formatDateZeroPadding(schedule.details.scheduleEndDate)}まで`
                }

                // 削除可否
                const deleteImpossibleFlg: boolean = schedule.details.controlFlag === YES_OR_NOT.NO.value

                await this.getEventList(
                    this.state.searchCondition,
                    this.state.searchConditionPageInfo,
                    this.state.searchConditionSortInfo,
                )

                ReactDOM.flushSync(() => {
                    if (schedule && schedule.details) {
                        this.setState({
                            schedule: schedule,
                            scheduleTitle: schedule.details.title,
                            eventCategory: eventCategory,
                            eventItem: eventItem,
                            scheduleTermDate: scheduleTermDate,
                            description: schedule.details.description,
                            scheduleSetting: getScheduleSettingInfo(
                                schedule.details.repeatDate,
                                schedule.details.repeatWeekUnit,
                                schedule.details.repeatWeek,
                                schedule.details.repeatDayOfWeek),
                            condominiumName: schedule.details.condominiumName,
                            condominiumGroupName: schedule.details.condominiumGroupName,
                            deliveryTargetPrefectureCd: schedule.details.deliveryTargetPrefectureCd ?
                                schedule.details.deliveryTargetPrefectureCd : '',
                            deliveryTargetAddress2: schedule.details.deliveryTargetAddress2 ?
                                schedule.details.deliveryTargetAddress2 : '',
                            scheduleNotDeliveryCondominium: schedule.details.scheduleNotDeliveryCondominium,
                            isLoadCompleted: true,
                            deleteImpossibleFlg: deleteImpossibleFlg,
                        })
                    }
                })
                // 配信対象物件一覧の設定
                await this.getSelectedDeliveryTargetCondominiumInfo(
                    schedule.details.condominiumGroupId,
                    this.state.deliveryTargetPrefectureCd,
                    this.state.deliveryTargetAddress2,
                )
            }
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // 配信対象物件一覧の取得
    async getSelectedDeliveryTargetCondominiumInfo(
        condominiumGroupId: Nullable<number>,
        deliveryTargetPrefectureCd: Nullable<string>,
        deliveryTargetAddress2: Nullable<string>,
    ): Promise<void> {
        if (deliveryTargetPrefectureCd !== '' || deliveryTargetAddress2 !== '') {
            const billingStatus: BillingStatus = {
                billingDeadline: null,
                confirmStatus: null,
                targetYearMonth: null,
                electedTargetYearMonth: null,
            }
            const searchCondition: SearchConditionList = {
                condominiumCd: null,
                condominiumName: null,
                condominiumGroupId: condominiumGroupId,
                prefectureCd: deliveryTargetPrefectureCd,
                address2: deliveryTargetAddress2,
                detailSearchCondition: null,
                billingStatus: billingStatus,
                unreleaseCondominiumExclusionFlg: null,
            }
            const searchConditionPageInfo: SearchConditionPageInfo = {
                pageNum: 0,
                page: 0,
            }
            const searchConditionSortInfo: SortOrder[] = [new SortOrder('condominiumCd', 'asc')]

            this.setState({
                scheduleDeliveryTargetCondominiumList:
                    await this.searchCondominiums(
                        searchCondition,
                        searchConditionPageInfo,
                        searchConditionSortInfo),
            })
        }
    }

    // 物件一覧検索結果の取得
    async searchCondominiums(
        searchCondition: SearchConditionList,
        searchConditionPageInfo: CondominiumSearchConditionPageInfo,
        searchConditionSortInfo: SortOrder[],
    ): Promise<CondominiumInfo[]> {
        const searchParams: string[] = []

        if (searchConditionSortInfo) {

            searchConditionSortInfo.forEach((sortInfo) => {
                const value: string = `${sortInfo.sortKey}:${sortInfo.sortDirection}`
                searchParams.push(`sortInfo=${value}`)
            })
        }

        // 物件一覧取得
        const getCondominiumResponse: Nullable<NatGetCondominiumList> =
            await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominiumList.bind(
                    this.props.condominiumRepo,
                    {...searchCondition, ...searchConditionPageInfo, sortInfo: searchParams},
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

        if (getCondominiumResponse) {
            if (getCondominiumResponse.details) {
                return getCondominiumResponse.details.condominiumInfo
            }
        }
        return []
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    backScheduleListLinkClick(): void {
        this.props.navigate(`/admin/calendar`)
    }

    editScheduleLinkClick(): void {
        this.props.navigate(`/admin/scheduleEdit/${this.props.scheduleId}`)
    }

    // 削除ボタン押下
    async deleteSchedule(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0011.errorLevel,
                message: Messages.IOPCC0011.toString('スケジュール'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleDeleteOkClick,
                    },
                ],
            },
        )
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleDeleteOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const deleteScheduleResponse: Nullable<NatDeleteSchedule> = await this.props.asyncCallFunction(
                this.props.scheduleRepo.deleteScheduler.bind(
                    this.props.scheduleRepo, this.props.scheduleId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (deleteScheduleResponse && deleteScheduleResponse.requestError === null) {
                this.props.navigate(`/admin/calendar/`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0006.toString('スケジュール', this.state.scheduleTitle),
                            },
                        },
                    },
                )
            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.page = newPage
        await this.getEventList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.pageNum = Number(event.target.value)
        searchConditionPageInfo.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.getEventList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }


    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    async getEventList(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfos: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const eventList: Nullable<NatGetEventList> = await this.props.asyncCallFunction(
                this.props.eventRepo.getEventList.bind(
                    this.props.eventRepo,
                    searchCondition,
                    searchConditionPageInfo,
                    [...searchConditionSortInfos, ...this.subSortKey]),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (eventList && eventList.details) {
                this.setState({
                    eventList: eventList.details.eventInfo,
                    eventSearchResult: eventList.details.searchResult,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }


    renderScheduleTable(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>スケジュール情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>タイトル</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.scheduleTitle}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>イベントカテゴリ</TableRowName>
                            <TableCell colSpan={2}>
                                {this.state.eventCategory}
                            </TableCell>
                            <TableRowName>イベント項目</TableRowName>
                            <TableCell colSpan={2}>
                                {this.state.eventItem}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>説明文</TableRowName>
                            <TableCellWordBreakAll colSpan={4}>
                                <div dangerouslySetInnerHTML={{__html: this.state.description}}/>
                            </TableCellWordBreakAll>
                        </TableRow>
                        <TableRow>
                            <TableRowName>実施期間</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.scheduleTermDate}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>設定内容</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.scheduleSetting}
                            </TableCell>
                        </TableRow>
                        {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                            <>
                                <TableRow>
                                    <TableRowName>対象グループ/物件</TableRowName>
                                    <TableCell colSpan={4}>
                                        {(this.state.condominiumName) ?
                                            this.state.condominiumName : this.state.condominiumGroupName}
                                    </TableCell>
                                </TableRow>
                                {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== '' ?
                                    <>
                                        <TableRow>
                                            <TableRowName>
                                                配信対象
                                            </TableRowName>
                                            <TableCell colSpan={4}>
                                                {`指定地域: ${this.getPrefectureName(this.state.deliveryTargetPrefectureCd)}
                                                ${this.state.deliveryTargetAddress2}`}
                                                {
                                                    <InnerMiniTable>
                                                        <InnerMiniTableBody>
                                                            {
                                                                this.state.scheduleDeliveryTargetCondominiumList.map(
                                                                    (condominiumInfo, index) => {
                                                                        return (
                                                                            <TableRow
                                                                                key={condominiumInfo.condominiumCd}>
                                                                                <InnerMiniTableCell>
                                                                                    {condominiumInfo.condominiumCd + ' ' +
                                                                                        condominiumInfo.condominiumName}
                                                                                </InnerMiniTableCell>
                                                                            </TableRow>
                                                                        )
                                                                    })
                                                            }
                                                        </InnerMiniTableBody>
                                                    </InnerMiniTable>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    </>
                                    : <></>
                                }
                                <TableRow>
                                    <TableRowName>除外する物件</TableRowName>
                                    {this.state.scheduleNotDeliveryCondominium.map((scheduleNotDeliveryCondominium) => (
                                        <TableRow>
                                            <TableCell>
                                                {scheduleNotDeliveryCondominium.condominiumCd}
                                            </TableCell>
                                            <TableCell colSpan={3}>
                                                {scheduleNotDeliveryCondominium.condominiumName}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {this.state.scheduleNotDeliveryCondominium.length === 0 &&
                                        <TableCell colSpan={4}></TableCell>
                                    }
                                </TableRow>
                            </>
                        }
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageHeaderArea(): Nullable<ReactNode> {
        if (this.state.deleteImpossibleFlg) {
            return (<></>)
        }
        return (
            <>
                <PageFotterAreaRight>
                    <DeleteLink
                        onClick={this.deleteSchedule}>
                        スケジュールを削除する
                    </DeleteLink>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <AdminPrimaryButton
                        onClick={this.editScheduleLinkClick}>
                        編集する
                    </AdminPrimaryButton>
                </PageFotterAreaLeft>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backScheduleListLinkClick}
                    >
                        スケジュール参照へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    renderPageBodyCondominiumAuthorityInfoArea(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>イベント一覧</StyledTableCaption>
                </Table>
            </>
        )
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            const prefecturesMaster = PREFECTURES_MASTER.codeToEnumConstants(prefectureCd)
            return prefecturesMaster.label
        } else {
            return ''
        }
    }

    renderEventRecord(event: EventInfo): ReactElement {
        const eventUrl: string = `/admin/event/${event.scheduleId}/${event.seq}`
        // 非表示
        let invisible: string = ''
        if (event.invisible) {
            const invisibleMaster =
                VALID_OR_NOT_CHECK.codeToEnumConstants(event.invisible)
            if (invisibleMaster) {
                invisible = invisibleMaster.label
            }
        }

        // 実施日変更済
        let dateChaneFlag: string = ''
        if (event.operationDate !== event.scheduleAssignDate) {
            dateChaneFlag = VALID_OR_NOT_CHECK.VALID.label
        } else {
            dateChaneFlag = VALID_OR_NOT_CHECK.NOT.label
        }

        return (
            <TableRow key={event.scheduleId + '_' + event.seq}>
                <TableCell align={'center'}>
                    <Link href={eventUrl} underline="hover">
                        {event.operationDate}
                    </Link>
                </TableCell>
                <TableCell align={'center'}>{invisible}</TableCell>
                <TableCell align={'center'}>{dateChaneFlag}</TableCell>
                <TableCell align={'center'}>{event.scheduleAssignDate}</TableCell>
            </TableRow>
        )
    }

    renderEventTable(messageList: EventInfo[]): Nullable<ReactElement> {
        const headers: SortableTableHeaderCell[] = [
            {id: 'date', label: '実施日'},
            {id: 'hidden', label: '非表示'},
            {id: 'dateChaneFlag', label: '実施日変更済'},
            {id: 'datePreChane', label: '変更前実施日'},
        ]

        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.eventSearchResult && this.state.eventSearchResult.total ?
                        this.state.eventSearchResult.total : 0,
                    rowsPerPage:
                        this.state.searchConditionPageInfo.pageNum ? this.state.searchConditionPageInfo.pageNum : 0,
                    page: this.state.searchConditionPageInfo.page ? this.state.searchConditionPageInfo.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >
                <SortableTableHeader
                    noWrap
                    headers={headers}
                />
                <SortablePaginationTableBody>
                    {messageList.map(
                        message => this.renderEventRecord(message),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_CALENDAR_MANAGEMENT}>
                    <Box mb={'15px'}>
                        <PageFooterArea>
                            {this.renderPageHeaderArea()}
                        </PageFooterArea>
                    </Box>
                </AuthorityChecker>
                <Box mb={'15px'}>
                    <PageMainArea>
                        {this.renderScheduleTable()}
                    </PageMainArea>
                </Box>
                <PageMainArea>
                    {this.renderPageBodyCondominiumAuthorityInfoArea()}
                    {this.renderEventTable(this.state.eventList)}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminScheduleDetailsPage)

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`
